<template>
    <div class="back_live">
       <iframe :src="$route.query.play_url" frameborder="0" style="width: 100%;height: 100%;"></iframe>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
    .back_live{
        width: 100%;
        height: 100vh;
    }
</style>